const initialState = {
  bssc: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BSC_SELECT":
      return {
        ...state,
        bssc: action.payload,
      };
    default:
      return state;
  }
}
